import { gql } from "urql";
export const CreateSimpleEmailTemplateMutation = gql `
    mutation CreateSimpleEmailTemplate($subject: String!, $body: String!) {
        simpleEmailTemplates {
            createSimpleEmailTemplate(
                input: { subject: $subject, body: $body }
            ) {
                simpleEmailTemplateId
                organizationId
                subject
                body
                createdAt
                updatedAt
            }
        }
    }
`;
export const UpdateSimpleEmailTemplateMutation = gql `
    mutation UpdateSimpleEmailTemplate(
        $simpleEmailTemplateId: String!
        $subject: String
        $body: String
    ) {
        simpleEmailTemplates {
            updateSimpleEmailTemplate(
                input: {
                    simpleEmailTemplateId: $simpleEmailTemplateId
                    subject: $subject
                    body: $body
                }
            ) {
                simpleEmailTemplateId
                organizationId
                subject
                body
                createdAt
                updatedAt
            }
        }
    }
`;
export const DeleteSimpleEmailTemplateMutation = gql `
    mutation DeleteSimpleEmailTemplate($simpleEmailTemplateId: String!) {
        simpleEmailTemplates {
            deleteSimpleEmailTemplate(
                simpleEmailTemplateId: $simpleEmailTemplateId
            ) {
                simpleEmailTemplateId
            }
        }
    }
`;
